import { render, staticRenderFns } from "./price-set.vue?vue&type=template&id=0ac524f5"
import script from "./price-set.vue?vue&type=script&lang=js"
export * from "./price-set.vue?vue&type=script&lang=js"
import style0 from "./price-set.vue?vue&type=style&index=0&id=0ac524f5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports